const { dataLayer } = require("../lib/analytics");

/*
 * Dashboard events (clicks):
 * - SeeInquiry
 * - ChatWithClient
 * - SendOffer
 * - ViewOffer
 * - DownloadBookingConfirmation
 *
 * On the inquiry modal (clicks):
 * - AcceptInquiry
 * - RejectInquiry
 */

$(document).on("click", "[data-gatype='dashboard-button']", (e) => {
  const target = $(e.currentTarget);
  const eventType = target.data("gavariant");
  const event = `artistDashboard${eventType}`;
  const forwardedInquiryContainer = target.closest(
    "[data-forwarded-inquiry-id]",
  );
  const forwardedInquiryId = forwardedInquiryContainer.data(
    "forwarded-inquiry-id",
  );
  dataLayer.push({
    event,
    forwarded_inquiry_id: forwardedInquiryId,
  });
});
